import Vue from 'vue'
import { Component, Inject, Model, Prop, Watch } from 'vue-property-decorator'
import * as api from "../api";
import { tree, cc } from "../utils";
import { Item, InputRow, Node } from "../models";
import FormRows from "../parts/FormRows";
import App from '../App'
import { shuffle, sleep, normalizeModel, bakeRemoteData } from '../utils'
import SelectNode from '../parts/SelectNode'
import { remoteOp } from "../helper";


const confirmMsg = '表单已被修改, 是否放弃保存?'

@Component({
  name: 'PortalNodeCreate',
  components: { FormRows },

  beforeRouteUpdate(this: PortalNodeCreate, to, from, next) {
    let shouldNext = true
    if (this.modified) {
      shouldNext = confirm(confirmMsg)
    }
    next(shouldNext ? undefined : false)
  },

  beforeRouteLeave(this: PortalNodeCreate, to, from, next) {
    let shouldNext = true
    if (this.modified) {
      shouldNext = confirm(confirmMsg)
    }
    next(shouldNext ? undefined : false)
  }
})
export default class PortalNodeCreate extends Vue {
  @Prop() callbacks: {
    append: (data) => void;
    update: (data) => void;
  }

  busy = false

  modified = false

  model: any = {}

  get inputs(): InputRow[] {
    let types = (this.$root.$children[0] as App).availableNodeTypes
    let typeOptions = types.map(v => ({value: v, text: v}))
    typeOptions.unshift({value: 'jump', text: '[ jump ]'})
    typeOptions.unshift({value: 'none', text: '[ none ]'})
    return [
      { widget: 'text', key: 'name', label: '名称' },
      { widget: 'select', key: 'type', label: '类型', values:  typeOptions},
      { widget: 'text', key: 'alias', label: 'alias' },
      { widget: 'text', key: 'class_list', label: 'class' },
      { widget: 'text', key: 'link', label: '重定向' },
      { widget: 'checkbox', key: 'need_login', label: '需登录' },
      { widget: 'text', key: 'tpl_index', label: '页面模板' },
      { widget: 'text', key: 'tpl_item', label: '项目模板' },
    ]
  }

  private _unwatch?: (()=>void)

  created() {
    this.reset()
  }

  @Watch('$route')
  $routeChanged() {
    if (this.$route.name === 'portal-node-create') {
      this.reset()
    }
  }

  beforeDestroy() {
    if (this._unwatch) {
      this._unwatch()
      this._unwatch = undefined
    }
  }

  private reset() {
    if (this._unwatch) {
      this._unwatch()
      this._unwatch = undefined
    }
    this.busy = false
    this.model = normalizeModel({}, this.inputs)
    this._unwatch = this.$watch('model', (oldValue, newValue) => {
      if (newValue && oldValue && newValue === oldValue)
        this.modified = true
    }, {deep: true})
  }

  save() {
    if (!this.modified) {
      if (!confirm('表单似乎未被修改, 是否继续?')) {
        return
      }
    }
    if (!this.model.name) {
      alert('请填写节点名称')
      return
    }
    if (!this.model.type) {
      alert('请填写节点类型')
      return
    }
    $(':focus', this.$el).blur()
    let data = bakeRemoteData(this.model, this.inputs)
    data.parent_id = parseInt(this.$route.params.nodeId)
    remoteOp(this, '保存', '节点', async () => {
      let result = await api.node.create(data)
      this.modified = false
      this.close()
      data.id = parseInt(result.id)
      this.callbacks.append(data)
    })
  }

  close() {
    this.$router.replace({ name: 'portal-node-list' })
  }
}
